import { Box, Stack, Typography } from "@mui/material";

type TSeverityBarIndicatorArgs = {
	align?: string;
};
export default function SeverityBarIndicator(props: TSeverityBarIndicatorArgs) {
	const { align } = props;

	return (
		<Stack spacing={1} alignSelf={align ?? "center"}>
			<Typography className="!font-montserrat !text-[8pt] !font-semibold text-default pl-1.5">CIT Severity</Typography>
			<Box className="rounded-md h-3 w-[525px] bg-gradient-to-r from-primary to-high-severity" />
			<Stack direction="row" justifyContent="space-between" className="w-full">
				<Typography component={"span"} className="!font-montserrat !text-[8pt] !font-semibold text-default pl-1.5">
					Low
				</Typography>
				<Typography component={"span"} className="!font-montserrat !text-[8pt] !font-semibold text-default pr-1.5">
					High
				</Typography>
			</Stack>
		</Stack>
	);
}
